let activeTrigger$ = null;

document.addEventListener('click', (event) => {
  const trigger$ = event.target.closest('[data-size-guide-open]');

  const openModal = (modal$, triggerToOpen$) => {
    activeTrigger$ = triggerToOpen$;

    const imageUrl = triggerToOpen$.dataset.sizeGuideImageUrl;
    const label =
      triggerToOpen$.dataset.sizeGuideLabel ||
      triggerToOpen$.textContent?.trim() ||
      'Guia de talles';

    const dialog$ = modal$.querySelector('.variant-picker-size-guide-modal__dialog');
    const image$ = modal$.querySelector('[data-size-guide-modal-image]');

    if (dialog$) {
      dialog$.setAttribute('aria-label', label);
    }

    if (image$ && imageUrl) {
      image$.setAttribute('src', imageUrl);
      image$.setAttribute('alt', label);
    }

    modal$.hidden = false;
    triggerToOpen$.setAttribute('aria-expanded', 'true');
    document.body.classList.add('size-guide-modal-open');
    document.documentElement.classList.add('overflow-hidden');
  };

  const closeModal = (modal$) => {
    modal$.hidden = true;

    const triggerToReset$ =
      activeTrigger$ ||
      document.querySelector('[data-size-guide-open][aria-controls="' + modal$.id + '"]');

    if (triggerToReset$) {
      triggerToReset$.setAttribute('aria-expanded', 'false');
    }

    activeTrigger$ = null;

    document.body.classList.remove('size-guide-modal-open');
    document.documentElement.classList.remove('overflow-hidden');
  };

  if (trigger$) {
    const modalId = trigger$.getAttribute('aria-controls');
    const modal$ = modalId ? document.getElementById(modalId) : null;

    if (!modal$) {
      return;
    }

    openModal(modal$, trigger$);
    return;
  }

  const close$ = event.target.closest('[data-size-guide-close]');

  if (close$) {
    const modal$ = close$.closest('[data-size-guide-modal]');

    if (!modal$) {
      return;
    }

    closeModal(modal$);
    return;
  }

  const modal$ = event.target.closest('[data-size-guide-modal]');

  if (modal$ && event.target === modal$) {
    closeModal(modal$);
  }
});
